import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DteInvalidationErrorLogDetailDTO } from "../../../types/hacienda/DteInvalidationErrorLogDetailDTO";
import { DteInvalidationErrorLogTableDTO } from "../../../types/hacienda/DteInvalidationErrorLogTableDTO";

interface DteInvalidationLogState {
    paginatedList: DteInvalidationErrorLogTableDTO[];
    paginator: any;
    selectedLog: DteInvalidationErrorLogDetailDTO | null;
    showDetailModal: boolean;
    isLoading: boolean;
    pageSize: number;
}

const initialState: DteInvalidationLogState = {
    paginatedList: [],
    paginator: null,
    selectedLog: null,
    showDetailModal: false,
    isLoading: false,
    pageSize: 10,
};

const dteInvalidationLogSlice = createSlice({
    name: "dteInvalidationLog",
    initialState,
    reducers: {

        setIsLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },

        setPaginatedList(state, action: PayloadAction<any>) {
            state.paginatedList = action.payload.content;
            state.paginator = action.payload;
        },

        clearPaginatedList(state) {
            state.paginatedList = [];
            state.paginator = null;
        },

        setSelectedLog(
            state,
            action: PayloadAction<DteInvalidationErrorLogDetailDTO | null>
        ) {
            state.selectedLog = action.payload;
        },

        setOpenDetailModal(state) {
            state.showDetailModal = true;
        },

        setCloseDetailModal(state) {
            state.showDetailModal = false;
            state.selectedLog = null;
        },

        setPageSize(state, action: PayloadAction<number>) {
            state.pageSize = action.payload;
        },
    },
});

export const {
    setIsLoading,
    setPaginatedList,
    clearPaginatedList,
    setSelectedLog,
    setOpenDetailModal,
    setCloseDetailModal,
    setPageSize,
} = dteInvalidationLogSlice.actions;

export default dteInvalidationLogSlice.reducer;
